export const CONFIG_TYPE = 'Configuration_Setting';

// Config keys
// This is temporary and will be pulling these from system settings
export const ADOBE_TARGET_SCRIPT = 'ADOBE_TARGET_SCRIPT';

// Local forage key
export const ADOBE_SESSION_ID_KEY = 'adobeSessionId';
